import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiLogIn, FiEye, FiEyeOff, FiHelpCircle } from 'react-icons/fi';
import toast from 'react-hot-toast';
import ForgetPassword from '../components/ForgetPassword';

const Login = () => {
  const [email, setEmail] = useState('admin@mst.com');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const { login } = useAuth();
  
  const currentYear = new Date().getFullYear();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const success = await login(email, password);
    
    if (success) {
      toast.success('Redirection en cours...');
      window.location.href = '/dashboard';
    } else {
      setError('Email ou mot de passe incorrect');
    }
    
    setLoading(false);
  };
  
  if (showForgetPassword) {
    return <ForgetPassword onBack={() => setShowForgetPassword(false)} />;
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-600 to-green-800 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img 
              src="/logo.png" 
              alt="MST Logo" 
              className="w-20 h-20 rounded-full object-cover shadow-lg border-4 border-white"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <h1 className="text-xl font-bold text-gray-800">MULTI SERVICE</h1>
          <h2 className="text-md font-semibold text-green-600">TECHNOLOGIES</h2>
          <p className="text-gray-500 text-sm mt-2">Application de gestion</p>
        </div>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <div className="relative">
              <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field pl-10"
                placeholder="admin@mst.com"
                required
              />
            </div>
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Mot de passe
            </label>
            <div className="relative">
              <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field pl-10 pr-10"
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
              </button>
            </div>
          </div>
          
          {/* Lien mot de passe oublié */}
          <div className="text-right mb-6">
            <button
              type="button"
              onClick={() => setShowForgetPassword(true)}
              className="text-sm text-green-600 hover:text-green-700 flex items-center gap-1 ml-auto"
            >
              <FiHelpCircle size={14} />
              Mot de passe oublié ?
            </button>
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 font-semibold"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            ) : (
              <>
                <FiLogIn size={18} />
                Se connecter
              </>
            )}
          </button>
        </form>
        
        {/* Pied de page */}
        <div className="mt-8 pt-4 border-t text-center">
          <p className="text-xs text-gray-400">
            &copy; {currentYear} MULTI SERVICE TECHNOLOGIES
          </p>
          <p className="text-xs text-gray-400 mt-1">
            Tous droits réservés
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;